<h2 class="title text-center" style="top: 31px;"
	*ngIf="showFiveStarSection == 0 && showFiveStarSectionNew == 0 && showNotFiveStarSection == 0">Thank you for
	supporting us! Please give us your feedback if we can
	improve.</h2>
<section class="work" style="padding: 70px 0 10px;"
	*ngIf="showFiveStarSection == 0 && showFiveStarSectionNew == 0 && showNotFiveStarSection == 0">
	<div class="container">
		<!-- <span class="backk"><a [routerLink]="['/home']"> <img loading="lazy" class="mb-2" src="../../../../assets/images/backcu.png"
					style="height: 40px;"> </a></span> -->
		<div class="row">
			<div class="col-lg-6 col-md-6 col-sm-12">
				<div class="textarea_side_feedback tags_btn">
					<div class="feedback_rating  pt-0">
						<p>
							<ngb-rating [(rate)]="currentRate" max="5" (rateChange)="ratingHover($event)"
								class="gift"></ngb-rating>
						</p>

					</div>
					<div class="right_side_feedback hidden-not-xs">

						<ng-container *ngFor="let url of url_names" class="">

							<a [ngClass]="{'active' : url.id == selectedAdmin}"
								(click)="changeTemp($event.target.value,url)" class="position-relative"> {{url.name}}
								<a (click)="delete_name(url.id)" class="clo_btn" *ngIf="show_add_name_btn == 1 "><i
										class="fa fa-times" aria-hidden="true"></i></a>

							</a>
						</ng-container>

					</div>
					<!-- <input type="" placeholder="Enter your name" [(ngModel)]="selectedTitle"> -->
					<button class="btn" (click)="optionalName(optional)" *ngIf="show_add_name_btn==1">optional</button>
					<textarea placeholder="Write feedback here..." [(ngModel)]="selected"
						*ngIf="optional==0 "> </textarea>
				</div>

				<div class="right_side_feedback">
					<!-- <ng-container *ngFor="let tmp of admins">
						<a [ngClass]="{'active' : tmp.id == selectedAdmin}" (click)="changeTemp($event.target.value,tmp)"> {{tmp.userName}} </a>
					</ng-container> -->
					<div class="tags_btn">
						<button (click)="sendTemp()" style="outline: none;"
							*ngIf="feedbackStatus == 1 && show_add_name_btn == 0">Send </button>
						<button *ngIf="feedbackStatus == 0 && show_add_name_btn == 0" class="dis_feed">Send</button>
						<button (click)="cancel()" style="outline: none;"
							*ngIf="feedbackStatus == 1 && show_add_name_btn == 0">Cancel </button>
						<button *ngIf="feedbackStatus == 0 && show_add_name_btn == 0" class="dis_feed">Cancel</button>
						<button *ngIf="show_add_name_btn == 1" (click)="sendTempSubadmin()">Send</button>
						<button *ngIf="show_add_name_btn == 1" (click)="cancel()">Cancel</button>

					</div>

				</div>


			</div>

			<div class="col-lg-6 col-md-6 col-sm-12">
				<div class="right_side_feedback hidden-xs">
					<div class="tags_btn">
						<button (click)="open_add_name_modal(add_name_modal)" class="add_name"
							*ngIf="show_add_name_btn == 1 ">Add name</button>
					</div>

					<!-- <a *ngFor="let url of url_names">{{url.name}}</a> -->

					<ng-container *ngFor="let url of url_names" class="">

						<a [ngClass]="{'active' : url.id == selectedAdmin}"
							(click)="changeTemp($event.target.value,url)" class="position-relative"> {{url.name}}
							<a (click)="delete_name(url.id)" class="clo_btn" *ngIf="show_add_name_btn == 1 "><i
									class="fa fa-times" aria-hidden="true"></i></a>

						</a>
					</ng-container>

				</div>
			</div>
		</div>
	</div>
</section>



<section id="five_star_section_new">

	<div class="feedback"
		*ngIf="showFiveStarSectionNew == 1 || (feedbackStatus == 0 && feedbackStar == 5 && url_version == 1)">
		<div class="container">
			<div class="row ">
				<div class="col-md-5 mx-auto text-center">
					<div class="feeds">
						<div class="new_feed_star">

							<img loading="lazy" src="../../../../assets/images/thank_you_star.png">
							<p class="mt-3 mb-3">
								{{reviewLink.sms_content}}
								<!-- We would love if you could share your great 5 star review on google! Just send us a
								screenshot of your google review to redeem your <u>$10 NTUC</u> voucher using the links
								below. -->
							</p>
							<h3>
								<div class="button-wrapper" *ngIf="show_review_link == 1">
									<p *ngIf="show_review_link == 1 && show_whatsapp_link == 1">Step 1</p>
									<a href="{{reviewLink.review_link}}" target="_blank"> Review Here</a>
								</div>
								<div class="button-wrapper" *ngIf="show_whatsapp_link == 1">
									<p *ngIf="show_review_link == 1 && show_whatsapp_link == 1">Step 2</p>
									<a href="{{reviewLink.Whatsapp_link}}" target="_blank"> Whatsapp Here</a>
								</div>
								<!-- <div>
									<span class="rev_stps">Step 1 &nbsp;&nbsp;&nbsp;&nbsp;</span>
									<span class="rev_stps">Step 2 &nbsp;&nbsp;&nbsp;&nbsp;</span>
								</div>
								<div>
									<a href="{{reviewLink.review_link}}" target="_blank"> Review Here</a>
									<a href="{{reviewLink.Whatsapp_link}}" target="_blank"> Whatsapp Here</a>
								</div> -->
								<!-- <a href="https://goo.gl/maps/Lyjgw5KYYzjmAomW6" target="_blank"> Review Here</a>
								<a href="https://wa.link/u13ou1" target="_blank"> Whatsapp Here</a> -->

							</h3>
							<img loading="lazy" src="../../../../assets/images/google_review.jpg" />
						</div>
					</div>
				</div>
			</div>

		</div>
	</div>
</section>
<section id="five_star_section">
	<div class="feedback"
		*ngIf="showFiveStarSection == 1 || (feedbackStatus == 0 && feedbackStar == 5 && url_version == 0)">
		<div class="container">
			<div class="row align-items-center	">
				<div class="col-md-6">
					<div class="feeds old">
						<!-- <h4> Redeem a $10 NTUC Voucher by leaving another 5 Star Google Review & screenshot and send to
							us via Whatsapp</h4> -->
						<h4> {{reviewLink.sms_content}}</h4>

						<p>
							<span class="rev_stps" *ngIf="show_review_link == 1 && show_whatsapp_link == 1">Step 1:
								&nbsp;&nbsp;&nbsp;&nbsp;</span>
							<a href="{{reviewLink.review_link}}" target="_blank" class="rev_btns"
								*ngIf="show_review_link == 1"> Google
								Review</a>
							<br>
							<!-- <span class="fi_th">&</span> -->
							<span class="rev_stps" *ngIf="show_review_link == 1 && show_whatsapp_link == 1">Step 2:
								&nbsp;&nbsp;&nbsp;&nbsp;</span> <a href="{{reviewLink.Whatsapp_link}}" target="_blank"
								class="rev_btns" *ngIf="show_whatsapp_link == 1"> Whatsapp Us</a>
						</p>

						<!-- <p>
							<span class="rev_stps">Step 1: &nbsp;&nbsp;&nbsp;&nbsp;</span> 
							<a
								href="https://goo.gl/maps/Lyjgw5KYYzjmAomW6" target="_blank" class="rev_btns"> Google
								Review</a>
							<br>
							<span class="rev_stps">Step 2: &nbsp;&nbsp;&nbsp;&nbsp;</span> <a
								href="https://wa.link/u13ou1" target="_blank" class="rev_btns"> Whatsapp Us</a>
						</p> -->
					</div>
				</div>
				<div class="col-md-6">
					<div class="feeds text-center">

						<img loading="lazy" src="../../../../assets/images/google_review.jpg" />
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
<section id="not_five_star_section">
	<div class="feedback" *ngIf="showNotFiveStarSection == 1">
		<div class="container">
			<div class="row ">
				<div class="col-md-12 text-center">
					<div class="feeds">
						<h2> "Thank you for your Review! We seek to improve our Service to serve you better in Future."
						</h2>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>

<!-- <ng-template #add_name_modal let-modal>
	<div id="add_name_modal" class="login_me" role="dialog">
		<div class="modal-content">
			<button type="button" style="outline: none;" (click)="modal.dismiss('Cross click')"
				class="close close_modal" data-dismiss="modal" aria-label="Close">
				<span aria-hidden="true">×</span> </button>
			<div class="modal-header">
				<h4 class="modal-title"> ADD NAME</h4>
			</div>

			<div class="modal-body">
				<form [formGroup]="name_form">
					<input type="text" class="form-control" formControlName="name">
					<ng-container *ngIf="submitted && nameV.name.errors">
						<p class="error-message-repair"
							*ngIf=" nameV.name.errors.required">
							Name is required!
						</p>
					</ng-container>
					<br>
					<a class="yellow_btn " (click)="add_name()">Submit</a>
				</form>
			</div>

		</div>
	</div>
</ng-template> -->

<ng-template #add_name_modal let-modal>
	<div id="login_modal" class="" role="dialog">
		<div class="modal-content plain_bg">
			<div class="modal-body">
				<button type="button" style="outline: none;" (click)="modal.dismiss('Cross click')"
					class="close close_modal" data-dismiss="modal" aria-label="Close">
					<span aria-hidden="true">×</span> </button>
				<div class="row">
					<div class="col-md-12">
						<div class="login_here">
							<form id="login-form" class="form_login" [formGroup]="name_form">
								<h3 class="text-center">Add Name</h3>
								<br>
								<div class="form-group">
									<input type="text" class="form-control" formControlName="name">
									<ng-container *ngIf="submitted && nameV.name.errors">
										<p class="error-message-repair" *ngIf=" nameV.name.errors.required">
											Name is required!
										</p>
									</ng-container>
								</div>
								<div class="form-group">
									<div class="row align-items-center">
										<div class="col-md-12 text-center">
											<div class="login_button mt-4">
												<a class="btn_design sing_in_btn" (click)="add_name()"> Submit </a>
											</div>
										</div>
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</ng-template>